import { transparentize } from "polished";
import { Colors, RainBow } from "../../../../design-tokens/colors";

export const keysToPlotConfirmed = [
  {
    key: "newCases",
    name: "Daily cases",
    color: Colors.Pink,
    isMainSeries: true,
  },
  {
    key: "averageNewCases",
    name: "7 days average cases",
    color: transparentize(0.3, Colors.LightBlue),
  },
];

export const keysToPlotActive = [
  {
    key: "totalActive",
    name: "Active cases",
    color: Colors.Orange,
    isMainSeries: true,
  },
  {
    key: "totalCases",
    name: "Total confirmed cases",
    color: transparentize(0.3, Colors.LightBlue),
  },
];

export const keysToPlotTests = [
  {
    key: "totalTests",
    name: "Number of tests",
    color: RainBow.GrassGreen,
    isMainSeries: true,
  },
];

export const keysToPlotRecovered = [
  {
    key: "totalRecovered",
    name: "Recovered cases",
    color: Colors.Green,
    isMainSeries: true,
  },
];

export const keysToPlotDeath = [
  {
    key: "newDeaths",
    name: "Daily deaths",
    color: Colors.Red,
    isMainSeries: true,
  },
  {
    key: "predictedNewDeath",
    name: "Predicted deaths",
    color: transparentize(0.3, Colors.LightBlue),
  },
];

export const keysToPlotFatality = [
  {
    key: "fatalityRate",
    name: "Fatality rate",
    color: Colors.Red,
    isMainSeries: true,
    unit: "%",
  },
];
